import React, { useCallback, useMemo, useState } from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import useArchivePartner from '../hooks/useArchivePartner';
import { IPartnerV3 } from '../models/partnerV3';
import CustomModal from '@/components/CustomModal';
import InputIdForm from '@/components/InputIdForm';
import ScopedCta from '@/components/ScopedCta';
import P from '@/components/text/P';
import { scopes } from '@/config';

const { Text } = Typography;

const StyledP = styled(P)`
  margin-bottom: 1rem;
`;

const ArchivePartner = ({
  partner,
  setPartner,
  loading,
  disabled = false,
}: {
  partner: IPartnerV3;
  setPartner: any;
  loading: boolean;
  disabled: boolean;
}) => {
  const [{ loading: archiveLoading }, archivePartner] = useArchivePartner(
    partner.id
  );
  const [showModal, setShowModal] = useState(false);
  const [inputtedId, setInputtedId] = useState({
    data: '',
    touched: false,
  });

  const handleClick = useCallback(() => {
    if (disabled) return;

    setShowModal(true);
  }, [setShowModal, disabled]);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setInputtedId({ data: '', touched: false });
  }, []);

  const hasError = useMemo(
    () => inputtedId?.data?.trim() !== partner.id,
    [partner.id, inputtedId]
  );

  const handleSubmit = useCallback(async () => {
    const { success } = await archivePartner(partner);
    if (success) {
      closeModal();
      setPartner({
        ...partner,
        is_archived: true,
      });
    }
  }, [archivePartner, closeModal, partner, setPartner]);

  return (
    <>
      <ScopedCta
        component={Text}
        onClick={handleClick}
        loading={loading || archiveLoading}
        disabled={disabled}
        requiredScopes={[scopes.MANAGE_LPVILLAGE_PARTNER]}
      >
        Archive
      </ScopedCta>
      <CustomModal
        open={showModal}
        onCancel={closeModal}
        title="You are about to archive this partner"
        okText="Archive Partner"
        cancelText="Close"
        okButtonProps={{
          disabled: hasError,
          loading: archiveLoading,
        }}
        width="30%"
        onOk={handleSubmit}
      >
        <InputIdForm
          placeholder="Partner-ID"
          text={
            <StyledP>
              To archive this partner, please enter the partner&apos;s ID:
            </StyledP>
          }
          hasError={hasError}
          inputtedId={inputtedId}
          setId={setInputtedId}
          inputName="archive-partner-modal"
        />
      </CustomModal>
    </>
  );
};

export default ArchivePartner;
